import useSWR from "swr"
import {API_URL} from "../constants/apiUrls"

export default function useLexiconItems(lexiconId) {
    const {data, mutate, error} = useSWR(lexiconId ? `${API_URL}/lexicons/${lexiconId}/items` : null)
    return {
        lexiconItems: data,
        mutateLexiconItems: mutate,
        isLoadingLexiconItems: !error && !data,
        isErrorLexiconItems: error
    }
}